import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import { aliyunSlideProps } from '@/components/Login/typings';
import { UserState } from '@/store/module/user';

export interface usernameProps extends aliyunSlideProps {
  // username: string | undefined;
  // password: string;
  loginInfo?: string | boolean;
}

export interface loginTypeProps {
  username?: string | undefined;
  password?: string;
  loginInfo?: string | boolean;
  needConfirmLogin?: boolean;
}

export function apiGetBypassword(data?: usernameProps) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.bypassword,
    data
  });
}

export function apiConfirmBypassword(data?: usernameProps) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.confirmBypassword,
    data
  });
}

// 获取手机号验证码
export interface getPhoneCodeProps {
  phone: string;
  event?: number;
  code?: number;
}
export interface getPhoneCodePropss {
  phone?: string;
  event?: number;
  code?: number;
  account?: string;
  type?: string;
}
export function apiGetPhoneCode(data: getPhoneCodePropss) {
  return request({
    method: 'POST',
    url: httpApi.user.getPhoneCode,
    data
  });
}

// 账号登录手机绑定
export interface bindPhoneProps {
  username?: string;
  password: string;
  phone: string;
  code?: number;
}
export function apiGetBindPhone(data: bindPhoneProps) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.bindPhoneByToken,
    data
  });
}

// 账号注册
export interface registerSliderProps {
  username: string;
  password: string;
  recoveryPwd?: string;
}

export function apiGetRegisterSlider(data: registerSliderProps) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.registerSlider,
    data
  });
}

// 手机号登录
export interface phoneLoginCaptchaProps extends aliyunSlideProps {
  phone: string;
  code?: number;
  check_account: number;
}

export function apiGetPhoneLoginCaptcha(data: phoneLoginCaptchaProps) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.phoneLoginCaptcha,
    data
  });
}

// 判断账号是否存在
export interface getPhonePreByUsernameProps {
  username: string;
}

export function apiGetPhonePreByUsername(data: getPhonePreByUsernameProps) {
  return request<string>({
    method: 'POST',
    url: httpApi.loginHome.getPhonePreByUsername,
    data
  });
}

interface phoneCodeProps {
  phone: string;
}

export interface accountPhoneCodeProps {
  account: string;
}

// 根据账号获取手机验证码
export function apiGetAccountPhoneCode(data: accountPhoneCodeProps) {
  return request<phoneCodeProps>({
    method: 'POST',
    url: httpApi.loginWindow.accountPhoneCode,
    data
  });
}

// 校验手机验证码
export interface checkPhoneCodeProps {
  account?: string;
  code: string;
}
export function apiGetCheckPhoneCode(data: checkPhoneCodeProps) {
  return request({
    method: 'POST',
    url: httpApi.user.checkPhoneCode,
    data
  });
}

// 手机验证码修改密码
export interface passwordProps {
  newpassword: string;
  repassword: string;
}

interface ChangeByPhoneProps extends aliyunSlideProps {
  newpassword?: string;
  repassword?: string;
  code?: string;
  phone?: string;
}
export interface ChangeByPhoneCodeProps {
  newpassword?: string;
  repassword?: string;
  code?: string;
  phone?: string;
}

export function apiGetChangeByPhone(data: ChangeByPhoneProps) {
  return request({
    method: 'POST',
    url: httpApi.PassWord.changeByPhone,
    data
  });
}

export interface FootprintJson {
  module_index: string;
  deed: string;
  relation_id: string;
}

export function footprint(data: FootprintJson) {
  return request({
    method: 'POST',
    url: httpApi.operation.footprint,
    data
  });
}

export function footprintV2(data: FootprintJson) {
  return request({
    method: 'POST',
    url: httpApi.operation.footprintV2,
    data
  });
}

export interface CollectJson {
  series?: number;
}

export function collect(data: CollectJson) {
  return request({
    method: 'POST',
    url: httpApi.collection.collect,
    data
  });
}

// 新设备验证

export interface VerifyJson {
  phoneCode: number | string;
  account: string;
}

export function apiVerify(data: VerifyJson) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.verify,
    data
  });
}

// 新设备验证

export interface VerifyMessageJson {
  pushType: string;
  pushSource: string;
  token: string;
}

export function apiVerifyMessage(data: VerifyMessageJson) {
  return request<UserState>({
    method: 'POST',
    url: httpApi.loginWindow.verifyMessage,
    data
  });
}

// 获取手机号验证码
export interface GetPhoneCodeData {
  phone?: string;
  event?: number;
  type?: string;
}

export function getPhoneCode(data: GetPhoneCodeData) {
  return request({
    method: 'POST',
    url: httpApi.user.getPhoneCode,
    data
  });
}

// 微软注册上报
export interface ApiClickBingData {
  type: number;
  clickId: string;
  deviceId: string;
  bingType: string;
}

export function apiClickBing(data: ApiClickBingData) {
  return request({
    method: 'POST',
    url: httpApi.loginWindow.clickBing,
    data
  });
}

// 激活数据上报第三方(优酷激活上报)
export interface ActiveReportData {
  clickId: string;
}

export function apiActiveReport(data: ActiveReportData) {
  return request({
    method: 'POST',
    url: httpApi.loginWindow.activeReport,
    data
  });
}

// 注册数据上报第三方(优酷+搜狗注册上报)
export interface RegisterReportData {
  clickId: string;
}

export function apiRegisterReport(data: RegisterReportData) {
  return request({
    method: 'POST',
    url: httpApi.loginWindow.registerReport,
    data
  });
}
